import { ElementRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { setChartSeries } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { setChartOption, setDataInLegendOption, setNameInLegendOption, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-options/chart-options.actions';
import { setFundChartNote } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/note/note.actions';
import { setFundChartPartner } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/partner/partner.actions';
import { setFundChartTitle } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/title/title.actions';
import { getDataInLegendDropdownConfig, getFundChartDropdownConfig, getNameInLegendDropdownConfig, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-options/chart-options.selectors';
import { hasValidRequestData } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart.selectors';
import { PARTNER_CHART_SIZES } from 'ChartApp/ts/apps/fund-chart-creator/constants';
import { NAME_IN_LEGEND_OPTIONS } from 'ChartApp/ts/features/charts-shared/constants';
import { DATA_IN_LEGEND_OPTIONS, EMBED_TYPE_IMAGE_CONTENTS, FUND_CHART_OPTIONS, } from 'ChartApp/ts/features/fundamental-chart/constants';
import { TabOptions } from 'ChartApp/ts/interfaces/fund-chart-common.interface';
import { FundChartCreatorAppStateManager } from 'ChartApp/ts/apps/fund-chart-creator/services/fund-chart-creator-app.service';
import { FundChartService } from 'ChartApp/ts/services/fund-chart.service';
import { AppStateManager } from 'NewAngular/services/app-state-manager.service';
import { LineAnnotationsModalComponent } from 'ChartApp/ts/features/fund-chart-page-shared/components/line-annotations-modal/line-annotations-modal.component';
import equal from 'NewAngular/utils/equal/deep-equal';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "ChartApp/ts/apps/fund-chart-creator/services/fund-chart-creator-app.service";
import * as i3 from "ChartApp/ts/services/fund-chart.service";
import * as i4 from "ChartApp/ts/features/charts-shared/components/chart-options/chart-options.component";
import * as i5 from "../../../../features/fund-chart-page-shared/components/line-annotations-modal/line-annotations-modal.component";
import * as i6 from "../../../../features/fund-chart-page-shared/components/line-annotations-tab/line-annotations-tab.component";
import * as i7 from "../../../../features/fund-chart-page-shared/components/fund-chart-view-controls/fund-chart-view-controls.component";
import * as i8 from "../../../../features/fund-chart-page-shared/components/fund-chart-correlations/fund-chart-correlations.component";
import * as i9 from "../../../../features/fund-chart-page-shared/components/fund-chart-data-format/fund-chart-data-format.component";
import * as i10 from "../../../../features/fund-chart-page-shared/components/fund-chart-list-browser/fund-chart-list-browser.component";
import * as i11 from "../../../../features/fund-chart-page-shared/components/fund-chart-metrics-list/fund-chart-metrics-list.component";
import * as i12 from "../../../../features/fund-chart-page-shared/components/fund-chart-securities-list/fund-chart-securities-list.component";
import * as i13 from "../../../../features/fund-chart-page-shared/components/presentation-chart/presentation-chart.component";
import * as i14 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i15 from "../../../../../../../../../ycharts/static/ts/features/components/inputs/simple-input/simple-input.component";
import * as i16 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/single-select-dropdown/single-select-dropdown.component";
import * as i17 from "../fund-chart-creator-header/fund-chart-creator-header.component";
import * as i18 from "ChartApp/ts/apps/fund-chart-creator/components/fund-chart-creator-panel-layout/fund-chart-creator-panel-layout.component";
const _c0 = (a0, a1) => ({ "is-panel-sidebar-shown": a0, "is-panel-sidebar-hidden": a1 });
const _c1 = a0 => ({ active: a0 });
const _c2 = () => ({ button: "btn btn-secondary btn-block" });
/**
 * Fund Chart Creator Page Component
 *
 * This is the top-level component of the fundamental chart creator app.
 *
 */
export class FundChartCreatorPageComponent {
    constructor(eltRef, store, fundChartCreatorAppStateService, fundChartService) {
        this.eltRef = eltRef;
        this.store = store;
        this.fundChartCreatorAppStateService = fundChartCreatorAppStateService;
        this.fundChartService = fundChartService;
        this.isSidebarOpen = true;
        this.noDataClass = 'get-started';
        this.noDataHTML = `<span>To get started,<br></span><span>add item from the left sidebar.</span>`;
        this.fundChartCreatorDropdownConfig = {
            title: {
                label: 'Chart Options',
            },
            list: [...FUND_CHART_OPTIONS],
        };
        this.dataInLegendDropdownConfig = {
            title: {
                label: 'Data in Legend',
            },
            list: [...DATA_IN_LEGEND_OPTIONS],
        };
        this.nameInLegendOptionsConfig = {
            title: {
                label: 'Name in Legend',
            },
            list: [...NAME_IN_LEGEND_OPTIONS],
        };
        this.chartSizesDropdownConfig = {};
        this.imageUrl = '';
        this.note = '';
        this.title = '';
        this.partnerId = '';
        this.partner = '';
        this.TabOptions = TabOptions;
        this.activeTab = TabOptions.INPUT;
        this.mapStateToComponent = (state) => {
            const { fundChart } = state;
            const chartHasValidRequestData = hasValidRequestData(state);
            this.fundChartCreatorDropdownConfig = getFundChartDropdownConfig(state);
            this.dataInLegendDropdownConfig = getDataInLegendDropdownConfig(state);
            this.nameInLegendOptionsConfig = getNameInLegendDropdownConfig(state);
            this.fundChartCreatorFormData = chartHasValidRequestData
                ? this.fundChartService.getFlattenedFormData(fundChart)
                : undefined;
            this.imageUrl = chartHasValidRequestData
                ? this.fundChartService.getChartEmbedUrl(fundChart, EMBED_TYPE_IMAGE_CONTENTS)
                : null;
            this.note = fundChart.note;
            this.partner = fundChart.partner;
            this.title = fundChart.title;
        };
        this.partnerId = this.eltRef.nativeElement.getAttribute('partnerId');
        this.fundChartCreatorAppStateService.initAppState();
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }
    ngOnInit() {
        const sizesByPartner = PARTNER_CHART_SIZES[this.partnerId];
        this.chartSizesDropdownConfig = {
            title: {
                label: 'Chart Sizes',
            },
            list: sizesByPartner,
        };
        // set default partner chart size
        this.setChartPartner(sizesByPartner[0].value);
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    setActiveTab(e, newTab) {
        e.preventDefault();
        this.activeTab = newTab;
    }
    updateChartOptions(newOption) {
        const newOptionProps = {
            label: newOption.label,
            value: newOption.value,
            selected: !!newOption.selected,
            trueValue: newOption?.trueValue,
            falseValue: newOption?.falseValue,
        };
        this.store.dispatch(setChartOption({ chartOption: newOptionProps }));
    }
    updateDataInLegend(dataInLegend) {
        this.store.dispatch(setDataInLegendOption({ dataInLegend }));
    }
    updateNameInLegend(nameInLegend) {
        this.store.dispatch(setNameInLegendOption({ nameInLegend }));
    }
    chartDataHandler(chartData) {
        if (equal(chartData, {})) {
            return;
        }
        // Both envelope shapes carry chart_data; cast to FundChartData[] so setChartSeries —
        // which stores the array in a slot typed as FundChartData[][] — type-checks. The
        // creator only reads metadata fields off these series, so dropping the extra full-data
        // fields is a runtime no-op.
        const series = (chartData.chart_data?.[0] ?? []);
        this.store.dispatch(setChartSeries({ series }));
    }
    setChartTitle(title) {
        this.store.dispatch(setFundChartTitle({ title }));
    }
    setChartNote(note) {
        this.store.dispatch(setFundChartNote({ note }));
    }
    setChartPartner(partner) {
        this.store.dispatch(setFundChartPartner({ partner }));
    }
    toggleSidebar() {
        this.isSidebarOpen = !this.isSidebarOpen;
    }
}
FundChartCreatorPageComponent.ɵfac = function FundChartCreatorPageComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartCreatorPageComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.FundChartCreatorAppStateManager), i0.ɵɵdirectiveInject(i3.FundChartService)); };
FundChartCreatorPageComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartCreatorPageComponent, selectors: [["ycn-fund-chart-creator-page"]], viewQuery: function FundChartCreatorPageComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(LineAnnotationsModalComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.lineAnnotationsModal = _t.first);
    } }, standalone: false, features: [i0.ɵɵProvidersFeature([{ provide: AppStateManager, useExisting: FundChartCreatorAppStateManager }])], decls: 57, vars: 36, consts: [[1, "page-header", "row", 3, "partnerId"], [1, "page-body", "panel", "panel-with-sidebar", "panel-fc-chart"], [1, "panel-wrap", "row"], [1, "panel-sidebar-wrap"], [1, "panel-sidebar", "bg-panel"], [1, "tabs", "user-select-none"], [1, "nav", "nav-tabs", "nav-width-equal"], [1, "nav-item"], ["href", "", 1, "nav-link", 3, "click"], [1, "tab-content", "panel-sidebar-scroll"], [1, "tab-pane"], [1, "panel-sidebar-section"], [3, "editAnnotationHandler"], ["ycnTooltip", "", "tooltipTitle", "Hide Controls", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "panel-sidebar-toggler", "panel-sidebar-toggler-close", 3, "click"], ["ycnIcon", "", "name", "icon-close-arrow"], [1, "panel-content-wrap"], [1, "panel-content"], [1, "row", "form-row"], ["ycnTooltip", "", "tooltipTitle", "Show Controls", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "panel-sidebar-toggler", "panel-sidebar-toggler-open", 3, "click"], ["ycnIcon", "", "name", "icon-open-arrow"], [1, "chart-options-cover", "col-i-3"], [3, "chartOptionChangeHandler", "dataInLegendChangeHandler", "nameInLegendChangeHandler", "chartOptionsConfig", "dataInLegendDropdownConfig", "nameInLegendOptionsConfig"], [1, "col-lg-4", "chart-title-cover", "form-inline"], [1, "form-label", "user-select-none"], ["buttonText", "Update", "placeholder", "Enter Title", 1, "input-group", 3, "handler", "value", "isClearable"], [1, "col-md-6", "col-lg-4", "chart-notes-cover", "form-inline"], ["buttonText", "Update", "placeholder", "Enter Notes", 1, "input-group", 3, "handler", "value", "isClearable"], [1, "col-md-6", "col-lg-4"], [1, "dropdown", 3, "changeHandler", "customCssClasses", "config", "selectedValue"], [1, "row", "row-full-height"], [1, "col-12"], [1, "chart-cover"], [1, "chart-presentation", "user-select-none"], [3, "chartDataHandler", "chartFormData", "imageUrl", "isFundChartCreator"]], template: function FundChartCreatorPageComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelement(0, "ycn-fund-chart-creator-header", 0);
        i0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "div", 5)(6, "ul", 6)(7, "li", 7)(8, "a", 8);
        i0.ɵɵlistener("click", function FundChartCreatorPageComponent_Template_a_click_8_listener($event) { return ctx.setActiveTab($event, ctx.TabOptions.INPUT); });
        i0.ɵɵtext(9, " Input ");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(10, "li", 7)(11, "a", 8);
        i0.ɵɵlistener("click", function FundChartCreatorPageComponent_Template_a_click_11_listener($event) { return ctx.setActiveTab($event, ctx.TabOptions.ANNOTATE); });
        i0.ɵɵtext(12, " Annotate ");
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(13, "div", 9)(14, "div", 10)(15, "section", 11);
        i0.ɵɵelement(16, "ycn-fund-chart-securities-list");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "section", 11);
        i0.ɵɵelement(18, "ycn-fund-chart-metrics-list");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "section", 11);
        i0.ɵɵelement(20, "ycn-fund-chart-list-browser");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "section", 11);
        i0.ɵɵelement(22, "ycn-fund-chart-data-format");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "section", 11);
        i0.ɵɵelement(24, "ycn-fund-chart-creator-panel-layout");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "section", 11);
        i0.ɵɵelement(26, "ycn-fund-chart-correlations");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(27, "div", 10)(28, "ycn-line-annotations-tab", 12);
        i0.ɵɵlistener("editAnnotationHandler", function FundChartCreatorPageComponent_Template_ycn_line_annotations_tab_editAnnotationHandler_28_listener($event) { return ctx.lineAnnotationsModal.openModal($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(29, "div", 13);
        i0.ɵɵlistener("click", function FundChartCreatorPageComponent_Template_div_click_29_listener() { return ctx.toggleSidebar(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(30, "svg", 14);
        i0.ɵɵelementEnd()()();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(31, "div", 15)(32, "div", 16)(33, "div", 17)(34, "div", 18);
        i0.ɵɵlistener("click", function FundChartCreatorPageComponent_Template_div_click_34_listener() { return ctx.toggleSidebar(); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(35, "svg", 19);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(36, "div", 20)(37, "ycn-chart-options", 21);
        i0.ɵɵlistener("chartOptionChangeHandler", function FundChartCreatorPageComponent_Template_ycn_chart_options_chartOptionChangeHandler_37_listener($event) { return ctx.updateChartOptions($event); })("dataInLegendChangeHandler", function FundChartCreatorPageComponent_Template_ycn_chart_options_dataInLegendChangeHandler_37_listener($event) { return ctx.updateDataInLegend($event); })("nameInLegendChangeHandler", function FundChartCreatorPageComponent_Template_ycn_chart_options_nameInLegendChangeHandler_37_listener($event) { return ctx.updateNameInLegend($event); });
        i0.ɵɵelementEnd()()();
        i0.ɵɵelement(38, "ycn-fund-chart-view-controls", 17);
        i0.ɵɵelementStart(39, "div", 17)(40, "div", 22)(41, "div", 23);
        i0.ɵɵtext(42, "Title");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(43, "ycn-simple-input", 24);
        i0.ɵɵlistener("handler", function FundChartCreatorPageComponent_Template_ycn_simple_input_handler_43_listener($event) { return ctx.setChartTitle($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(44, "div", 25)(45, "div", 23);
        i0.ɵɵtext(46, "Notes");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "ycn-simple-input", 26);
        i0.ɵɵlistener("handler", function FundChartCreatorPageComponent_Template_ycn_simple_input_handler_47_listener($event) { return ctx.setChartNote($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(48, "div", 27)(49, "ycn-single-select-dropdown", 28);
        i0.ɵɵlistener("changeHandler", function FundChartCreatorPageComponent_Template_ycn_single_select_dropdown_changeHandler_49_listener($event) { return ctx.setChartPartner($event); });
        i0.ɵɵelementEnd()();
        i0.ɵɵelement(50, "div", 29);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "div", 29)(52, "div", 30)(53, "div", 31)(54, "div", 32)(55, "ycn-presentation-chart", 33);
        i0.ɵɵlistener("chartDataHandler", function FundChartCreatorPageComponent_Template_ycn_presentation_chart_chartDataHandler_55_listener($event) { return ctx.chartDataHandler($event); });
        i0.ɵɵelementEnd()()()()()()()()();
        i0.ɵɵelement(56, "ycn-line-annotations-modal");
    } if (rf & 2) {
        i0.ɵɵproperty("partnerId", ctx.partnerId);
        i0.ɵɵadvance();
        i0.ɵɵclassMap(i0.ɵɵpureFunction2(24, _c0, ctx.isSidebarOpen, !ctx.isSidebarOpen));
        i0.ɵɵadvance(7);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(27, _c1, ctx.activeTab === ctx.TabOptions.INPUT));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(29, _c1, ctx.activeTab === ctx.TabOptions.ANNOTATE));
        i0.ɵɵadvance(3);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(31, _c1, ctx.activeTab === ctx.TabOptions.INPUT));
        i0.ɵɵadvance(13);
        i0.ɵɵclassMap(i0.ɵɵpureFunction1(33, _c1, ctx.activeTab === ctx.TabOptions.ANNOTATE));
        i0.ɵɵadvance(10);
        i0.ɵɵproperty("chartOptionsConfig", ctx.fundChartCreatorDropdownConfig)("dataInLegendDropdownConfig", ctx.dataInLegendDropdownConfig)("nameInLegendOptionsConfig", ctx.nameInLegendOptionsConfig);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("value", ctx.title)("isClearable", true);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("value", ctx.note)("isClearable", true);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("customCssClasses", i0.ɵɵpureFunction0(35, _c2))("config", ctx.chartSizesDropdownConfig)("selectedValue", ctx.partner);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("chartFormData", ctx.fundChartCreatorFormData)("imageUrl", ctx.imageUrl)("isFundChartCreator", true);
    } }, dependencies: [i4.ChartOptionsComponent, i5.LineAnnotationsModalComponent, i6.LineAnnotationsTabComponent, i7.FundChartViewControlsComponent, i8.FundChartCorrelationsComponent, i9.FundChartDataFormatComponent, i10.FundChartListBrowserComponent, i11.FundChartMetricsListComponent, i12.FundChartSecuritiesListComponent, i13.PresentationChartComponent, i14.IconDirective, i15.SimpleInputComponent, i16.SingleSelectDropdownComponent, i17.FundChartCreatorHeaderComponent, i18.FundChartCreatorPanelLayoutComponent], encapsulation: 2 });
